import * as React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@lightspeed/flame/Core';
import { Popover } from '@lightspeed/flame/Popover';
import { Text } from '@lightspeed/flame/Text';

import Indicator from '~/renderer/components/ConnectionStatus/StatusIndicator';
import { getConnectionStatus } from '~/renderer/store/connection/selectors';

import { StatusIndicatorWrapper } from './StatusIndicator.style';

interface Props {
  isVisible: boolean;
}

const StatusIndicator: React.FunctionComponent<Props> = ({ isVisible }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const status = useSelector(getConnectionStatus);

  if (!isVisible) return null;

  return (
    <StatusIndicatorWrapper data-testid="status-indicator">
      <Popover
        placement="top-start"
        target={({ targetProps, targetEvents }) => (
          <Box
            data-testid="status-indicator-popover-button"
            px={1}
            pb={1}
            {...targetProps}
            {...targetEvents}
            onClick={() => handleOpen()}
            style={{ cursor: 'pointer' }}
          >
            <Indicator status={status} />
          </Box>
        )}
        isOpen={isOpen}
        onClose={() => handleClose()}
      >
        <Box p={2} style={{ minWidth: '250px' }}>
          {status ? <Text pb={1}>{status}</Text> : null}
        </Box>
      </Popover>
    </StatusIndicatorWrapper>
  );
};

export default StatusIndicator;
